import emailjs from "emailjs-com";
import { useState } from "react";
import { FaWindowClose } from "react-icons/fa";
import Bounce from "react-reveal/Bounce";

const Contact = (e) => {
	const [success, setSuccess] = useState("");
	function sendEmail(e) {
		e.preventDefault();
		emailjs
			.sendForm("gmail", "portfolio", e.target, "user_n4n296RWZOu4TmdX5FxKI")
			.then((result) => {
				e.target.reset();
				setSuccess("Message sent successfully.");
				setTimeout(() => {
					setSuccess("");
				}, 3000);
			});
	}
	return (
		<div>
			<Bounce right>
				<button
					className="btn btn-danger font-weight-bold"
					type="button"
					data-toggle="modal"
					data-target="#contactModal"
				>
					Send Message
				</button>
			</Bounce>
			<div
				className="modal fade"
				id="contactModal"
				tabIndex="-1"
				aria-labelledby="contact-modal"
				aria-hidden="true"
			>
				<div className="modal-dialog">
					<div className="modal-content bg-dark">
						<div className="modal-header text-white">
							<h5 className="modal-title" id="contact-modal">
								Contact with Tamim
							</h5>
							<button
								type="button"
								className="close text-warning"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">
									<FaWindowClose />
								</span>
							</button>
						</div>
						<div className="modal-body">
							<form className="contact-form" onSubmit={sendEmail}>
								<div className="form-group">
									<input
										type="text"
										className="form-control"
										id="name"
										name="name"
										required
										placeholder="Your name"
									/>
								</div>
								<div className="form-group">
									<input
										type="email"
										className="form-control"
										id="email"
										name="email"
										required
										placeholder="Your email address"
									/>
								</div>
								<div className="form-group">
									<textarea
										className="form-control"
										id="message"
										name="message"
										required
										placeholder="Enter your message.."
										rows="4"
									></textarea>
								</div>
								{success ? (
									<p className="bg-success btn-block p-2 text-white rounded">
										{success}
									</p>
								) : (
									<input
										className="btn btn-danger btn-block"
										type="submit"
										value="Send"
									/>
								)}
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Contact;
